import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../../styles/EstimatingGuidance.css";
import AOS from "aos";
import "aos/dist/aos.css";

import "../../styles/Home.css";
import LiveTakeoffHero from "./components/LiveTakeoffHero";
import GlassComponent from "./components/GlassComponent";
import Services from "./components/Services";
import TrustPartner from "./components/TrustPartner";
import Feature from "./components/Feature";

export default function Home() {

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true, // animate only once when scrolled into view
    });
  }, []);

  return (
    <>
      <LiveTakeoffHero />

      <Feature />
      <GlassComponent />
      <TrustPartner />
      <Services />
      <section className="estimating-guide"><div className="estimating-guide-inner">
        <span className="estimating-guide-label">CONSTRUCTION ESTIMATING SUPPORT</span>
        <h2>From material quantities to your next bid.</h2>
        <p>Surya Group is a construction estimating company supporting contractors with material takeoffs and cost estimates. Start with the service that fits your scope: quantities for purchasing, a trade-specific estimate, or estimating support across multiple trades.</p>
        <nav aria-label="Estimating resources"><Link to="/material-takeoff-services">Explore material takeoff services →</Link><Link to="/general-contractor">General contractor estimating support →</Link><Link to="/schedule-meeting">Discuss your project →</Link></nav>
      </div></section>
    </>
  );
}
